#     _    _                 _
#    / \  | |__   ___  _   _| |_
#   / _ \ | '_ \ / _ \| | | | __|
#  / ___ \| |_) | (_) | |_| | |_
# /_/   \_\_.__/ \___/ \__,_|\__|
#

about:
    heading: Über
    aboutHtml: <span> <b>Produktname</b> <br />Enlivio </span> <br /> <br /> <span>
        <b>Hersteller</b> <br /> room4 Softwareentwicklung GmbH <br /> Henneberggasse
        2-6, 1030 Wien, Österreich </span> <br /> <br /> <span> <b>Jahr der Veröffentlichung</b> 2022
        </span> <br /> <span> <b>Aktuelle Release-Version</b> {{version}} </span> <br />
        <br /> <a href="https://www.enlivio.com/intendeduse/" target="_blank" rel="noopener noreferrer">
        Verwendungszweck </a> <br /> <br /> <a href="https://room4physio.atlassian.net/servicedesk/customer/portal/3/group/4/create/26"
        target="_blank" rel="noopener noreferrer"> Einen Vorfall melden </a>

#     _                             _
#    / \   ___ ___ ___  _   _ _ __ | |_
#   / _ \ / __/ __/ _ \| | | | '_ \| __|
#  / ___ \ (_| (_| (_) | |_| | | | | |_
# /_/   \_\___\___\___/ \__,_|_| |_|\__|
#

# components/MyAccountOverview
myAccountOverview:
    recommendationTitle: Empfehle uns weiter
    referralSignupLink: Empfehlungslink
    creditOverview: Guthabenübersicht
    creditText: Detaillierte Informationen über die Dauer der Sitzungen findest du unter "Trainingshistory" in deinen Profileinstellungen
    currentCredit: Aktuelles Guthaben
    myAccount: Mein Konto
    buyCredits: Guthaben aufladen
    patientContactOptionHeading: Kontaktmöglichkeiten
    allowChatLabel: Erlaube dem/der Patient:in, mir eine persönliche Chat-Nachricht zu senden
    patientContactOptionBody: Patient:innen können deine Kontaktdaten in der mobilen App einsehen, um dich zu kontaktieren. Diese sehen
        immer deine E-Mail, aber du kannst auswählen, ob deine Telefonnummer stattdessen angezeigt werden soll.
    patientContactOptionSwitch: Telefonnummer anzeigen
    yourAccountData: Deine Kontodaten
    recommendationText: Schenke deinen Kolleg:innen und dir selbst <strong>5 Gratisstunden</strong>. Diese werden für dich
        freigeschaltet, sobald jemand auf deine Einladung hin die ersten fünf Videotherapiestunden gehalten hat. Teile
        dafür einfach deinen persönlichen Empfehlungslink.
    appointmentHeading: Terminverlauf
    appointmentPatient: Patient:in
    appointmentDate: Datum
    appointmentStartTime: Startzeit
    appointmentEndTime: Endzeit
    appointmentDuration: Dauer
    tabAccount: Übersicht
    tabTrainingsHistory: Teletherapie
    tabAppointmentHistory: Terminverlauf
    tabBillingLabel: Abrechnung
    tabAvailability: Buchungseinstellungen
    privacyPolicy: Datenschutz-Bestimmungen
    termsAndConditions: Geschäftsbedingungen
    contractTitle: Datenschutzerklärung & Behandlungsvertrag
    contractDescription: Patient:innen müssen deiner Datenschutzerklärung und deinen Geschäftsbedingungen zustimmen, wenn sie mit dir
        ein Therapieverhältnis eingehen möchten.
    availability:
        title: Buchungseinstellungen
        description: Gib hier deine Profilinformationen und verfügbaren Zeiten an. Patient:innen können diese Informationen sehen und
            dann Termine in diesen Zeitfenstern anfragen.
        aboutYou: Über dich
        aboutDescription: Lass deine Patient:innen etwas über dich wissen.
        uploadImage: Bild ändern
        yourDescription: Deine Beschreibung
        yourService: Deine Spezialisierungen (bitte gib maximal 3 an.)
        weeklyHours: Deine Wochenstunden
        bookBefore: Terminanfragen bis Stunden vor Termin.
        hourDropdown: 4,8,12,24,48,72
        hourLabel: Std
        days:
            mon: Montag
            tue: Dienstag
            wed: Mittwoch
            thu: Donnerstag
            fri: Freitag
            sat: Samstag
            sun: Sonntag
        validation:
            aboutError: Bitte gib eine kurze Beschreibung an damit Patient:innen dich besser finden können.
            noAvailability: Du musst mindestens eine Verfügbarkeit angeben.
            picRequired: Bitte lade dein Profilbild hoch.
            specializationRequired: Bitte gib mindestens eine Spezialisierung an.
            invalidTime: Ungültige Zeit! Stelle bitte sicher, dass die Endzeit immer nach der Startzeit liegt.
            privacyPolicy: Datenschutzerklärung erforderlich.
            termsAndCondition: Allgemeine Geschäftsbedingungen sind erforderlich.
        buttons:
            addTimeSlot: Wochenstunden hinzufügen
            dismissTimeSlot: Wochenstunden entfernen

planDetails:
    currencySymbol: €
    planButton: Jetzt Starten
    confirmPlanTitle: Plan bestätigt
    confirmPlanBody: Dein Abo wird mit {planStartDate} automatisch beginnen.
    planConfirmButton: Weiter
    planCancelButton: Abbrechen
    choosePlanLabel: Wähle einen Plan aus
    currentPlan: Derzeitiger Plan
    upgradePlanButton: Upgrade-Plan
    upgradeCancelButton: Abbrechen
    nextPaymentLabel: 'Preis: {price} / Monat'
    planWillBeCanceled: Dein Plan wurde gekündigt und wird nach dem {endDate} nicht verlängert
    cancelSubscription: Abonnement kündigen
    upgradeModalTitle: Upgrade-Plan
    upgradeSuccessTitle: Upgrade erfolgreich planen
    upgradeSuccessBody: Du wirst per E-Mail benachrichtigt
    cancelModalTitle: Möchtest du wirklich kündigen?
    cancelModalBody:  Wenn du kündigst, wird dein Abonnement bis zum {endDate} gekündigt. Du kannst nicht mehr auf dein Konto zugreifen.
    cancelButton: Abonnement kündigen
    cancelSuccessTitle: Dein Plan wurde storniert
    cancelSuccessBody: Du wirst per E-Mail benachrichtigt

#     _       _           _
#    / \   __| |_ __ ___ (_)_ __
#   / _ \ / _` | '_ ` _ \| | '_ \
#  / ___ \ (_| | | | | | | | | | |
# /_/   \_\__,_|_| |_| |_|_|_| |_|
#

#containers/admin/Therapists
adminTherapistsContainer:
    buttons:
        refresh: Refresh
        refreshLoading: Loading...

#containers/Admin/AdminVideoList
adminVideoListContainer:
    buttons:
        refresh: Reset
        refreshWhileLoading: Refreshing...
        next: Next
        nextNoMore: No More

#containers/Admin/InsurancePlan
insurancePlanContainer:
    labels:
        planCode: Plan Code
        planName: Plan Name
        headerTitle: Titel
        videoUrl: Video URL (optional)
        price: Preis

#containers/Admin/QuestionsInsurancePlan
questionsInsurancePlanContainer:
    labels:
        selectPlan: Plan auswählen


#     _                      _       _                        _
#    / \   _ __  _ __   ___ (_)_ __ | |_ _ __ ___   ___ _ __ | |_
#   / _ \ | '_ \| '_ \ / _ \| | '_ \| __| '_ ` _ \ / _ \ '_ \| __|
#  / ___ \| |_) | |_) | (_) | | | | | |_| | | | | |  __/ | | | |_
# /_/   \_\ .__/| .__/ \___/|_|_| |_|\__|_| |_| |_|\___|_| |_|\__|
#         |_|   |_|

# components/sessions/CreateManualSessionForm
createManualSessions:
    labels:
        date: Datum der Sitzung
        startTime: Beginn der Sitzung
        endTime: Ende der Sitzung
        submit: Neue "vor Ort"-Sitzung anlegen
    validation:
        date: Bitte Datum der Sitzung eingeben.
        startTime: Bitte korrekte Zeit für den Beginn der Sitzung eingeben.
        endTime: Bitte korrekte Zeit für das Ende der Sitzung eingeben.
        startTimeEndTime: Das Ende der Sitzung muss nach dem Beginn der Sitzung sein.
    modalTitle: Termin erstellen
    deleteModal:
        title: Termin löschen
        body: Möchtest Du den Termin wirklich löschen?

# components/appointment/createAppointmentForm
createAppointmentForm:
    modalTitle: Termin erstellen
    labels:
        date: Datum
        startTime: Startzeit
        endTime: Endzeit
        submit: Termin erstellen
        selectDuration: Dauer
        min: Min.
        cancel: Absagen
        delete: Absagen
        reject: Ablehnen
        accept: Bestätigen
        allTime: Alle
        availableTime: Erhältlich
        selectedTime: null
        selectedTimeAt: von
        bookedTooltip: Gebucht
        noAvailableTime: Keine verfügbaren Zeitfenster
    validation:
        date: Bitte gib das Datum ein.
        startTime: Bitte gib die Startzeit ein.
        endTime: Bitte gib die Endzeit ein.
        startTimeEndTime: Die Endzeit muss nach der Startzeit liegen.
        pastDate: Das Datum liegt in der Vergangenheit.
        pastTime: Zeit in der Vergangenheit.
        invalidDate: Ungültiges Datum! Das korrekte Datumsformat ist TT-MM-JJJJ
    deleteModal:
        title: Termin löschen
        body: Möchtest du den Termin wirklich löschen?
    acceptModal:
        title: Termin bestätigen
        body: Möchtest du den Termin wirklich bestätigen?
    rejectModal:
        title: Termin ablehnen
        body: Möchtest du den Termin wirklich ablehnen?
    appointmentStatus:
        pending: STEHT AUS
        confirmed: BESTÄTIGT
        cancelled_by_therapist: STORNIERT
        cancelled_by_patient: STORNIERT
        rejected: ABGELEHNT
        requested: BESTÄTIGT
        cancelled: STORNIERT
    fcmRoomCreatedTitle: Teletherapie gestartet.
    fcmRoomCreatedBody: Dein:e Therapeut:in hat die Teletherapie gestartet.
    fcmHostLeftTitle: Teletherapie beendet.
    fcmHostLeftBody: Dein:e Therapeut:in hat die Teletherapie verlassen.
    noAppointmentData: Kein Termin gefunden.
    fcmAppointmentReminderMin: 3
    fcmAppointmentReminderTitle: Terminerinnerung
    fcmAppointmentReminderBody: Deine Therapiesitzung mit {first_name_of_therapist} beginnt gleich. Jetzt beitreten!

# components/SessionList
sessionList:
    createButton: Neue "vor Ort"-Sitzung anlegen
    modalTitle: Neue "vor Ort"-Sitzung
    online: online
    offline: vor Ort

# components/ScheduleSession
scheduleSession:
    labels:
        inviteEmailAddress: E-Mail-Adresse Patient:in
        shouldSendInviteEmail: Einladung per E-Mail versenden
        start: Start
        end: Ende
        inviteMessage: Nachricht
        dateSelectionText: Selektiere den gewünschten Termin im Kalender
    buttons:
        createAppointmentAndSendInvitation: Termin erstellen & Einladung versenden
        createAppointment: Termin erstellen
    placeholders:
        inviteMessage: Hallo, dein:e Therapeut:in lädt dich zur online Physiotherapie ein

# containers/TherapyDetails
therapyDetails:
    appointments:
        title: Termine
        button: Neuer Termin
        requestTitle: Terminanfrage
    meetings:
        title: Verlauf
    workouts:
        title: Trainingsplan
    questionnaire:
        title: Fragebögen
    answerAndActivity:
        title: Statistiken & Aktivität
    resendActivationEmail:
        button: Aktivierungsmail erneut senden
        body: Die Patient:in <strong>{{email}}</strong> hat das Konto noch nicht aktiviert. Klicke hier um die Aktivierungs-Email erneut zu senden.
        successMsg: Aktivierungs-E-Mail erfolgreich an {{email}} gesendet.

#     _         _   _
#    / \  _   _| |_| |__
#   / _ \| | | | __| '_ \
#  / ___ \ |_| | |_| | | |
# /_/   \_\__,_|\__|_| |_|
#

# every localization string of auth0-lock is overridable
auth0lock:
    languageDictionary:
        loginSubmitLabel: Log-in
        loginWithLabel: Log-in mit %s
        signUpTerms: Mit der Registrierung stimmst du unseren <a href="https://www.enlivio.com/wp-content/uploads/2021/11/AGB_Enlivio_B2B_v3_inclAVV_Physio.pdf" target="_blank">AGB</a> und der <a href="https://www.enlivio.com/wp-content/uploads/2021/11/20211027-heyData_Datenschutzerklärung-Website_DE_room4-Softwareentwicklung-GmbH_https___app.enlivio.com-1.pdf" target="_blank">Datenschutzerklärung</a> zu
        emailInputPlaceholder: deineEmail@beispiel.com
        passwordInputPlaceholder: Dein Passwort
        genericError: Es existiert bereits ein Konto mit dieser Email. Bitte nutze das Anmeldefenster und melde dich mit deinem Benutzernamen(Email) und Passwort an. Solltest du dein Passwort vergessen haben, kannst du dieses dort zurücksetzen.

loginBox:
    loginSubmitLabel: Log-in
    loginSubmitLabelLoading: Logging in

# accountSetup
accountSetup:
    heading: Nur noch ein Schritt zum Account
    personalDetailLabel: Persönliche Daten
    choosePlanLabel: Wähle einen Plan aus
    therapistSubheading: Bitte ergänze noch folgende Details
    gisaEntry: Wir prüfen deine Zulassung/Berufsberechtigung, um die Vertrauenswürdigkeit unserer Plattform zu gewährleisten.
    notRegistered: Nicht als Physiotherapeut:in gemeldet?
    contactUs: Kontaktiere uns
    firstName: Vorname
    lastName: Nachname
    street: Straße, Hausnummer
    postal: PLZ
    city: Ort
    telephone: Telefonnummer
    dateOfBirth: Geburtsdatum (DD MM YYYY)
    completeRegistration: Weiter
    firstNameRequired: Bitte Vornamen eingeben.
    lastNameRequired: Bitte Nachnamen eingeben.
    pleaseFillIn: Bitte ausfüllen.
    invalidPhone: Die Telefonnummer darf keine Leerzeichen, Abstände oder Sonderzeichen enthalten.
    ageValidation: Das Alter muss im Bereich von 18 bis 100 Jahren liegen.
    country: Land
    countryList: Österreich,Deutschland,Schweiz
    choosePlan: Wähle deinen Plan
    yourPlan: Dein Plan
    choosePlanLinkText: mehr Info...
    choosePlanLink: https://www.enlivio.com/wp-content/uploads/2021/11/Einzelvertrag_StarterFree_v2.pdf
    promptRequired: Bitte ausfüllen!
    promptRequiredFirstName: Bitte Vornamen eingeben!
    promptRequiredLastName: Bitte Nachnamen eingeben!
    promptValidDate: Bitte gültiges Datum auswählen!

# components/loginSignup/LoginPageLayout
loginPage:
    welcome: Willkommen bei Enlivio
    patients: Patient:innen
    trainers: Therapeut:innen
    trainersSubheading: Melde dich jetzt bei Enlivio an, um deine Patient:innen auch online und digital weiter zu betreuen. Enlivio ist ein Medizinprodukt, Informationen zur Zweckbestimmung findest du <a href="https://www.enlivio.com/intendeduse/" target="_blank">hier</a>
    goToLogin: Anmeldung
    goToSignup: Benutzerkonto erstellen
    RegisteredAccount: Du hast bereits einen Account?
    noRegisteredAccount: Du hast noch keinen Account?
    emailVerifiedBody: Deine Email wurde bestätigt.
    emailVerifiedButton: Ok
    joinRoomHeading: Code eingeben
    joinRoomDescription: Code eingeben und mit 1 Klick zur Physiotherapie
    joinRoomButton: Raum betreten
    joinRoomSupport: >
        Etwas funktioniert nicht? <br />
        <a href="mailto:info@enlivio.com">Kontaktiere unseren Support!</a>
    joinRoomEmptyError: Bitte gib den Raumcode ein!
    joinRoomLengthError: Bitte gib mindestens 4 Zeichen für den Raumcode ein


#   ____ _           _
#  / ___| |__   __ _| |_
# | |   | '_ \ / _` | __|
# | |___| | | | (_| | |_
#  \____|_| |_|\__,_|\__|
#

#components/chat/ChatComponents
chat:
    sendBtn: Senden
    searchPlaceholder: Suche
    typeMsgPlaceholder: Gib deine Nachricht ein
    offlineLabel: Offline
    onlineLabel: Online
    therapistNameLabel: Sie
    chatErrorTitle: Nicht authorisiert
    chatErrorBody: Du bist nicht mit dem Chat verbunden!
    retryButtonText: Verbinden
    noPatientFound: Keine Patient:in gefunden
    noChatMessageFound: Keine Chatnachricht gefunden
    openPatientProfile: Patient:innenprofil öffnen
    sendingFailed: Senden fehlgeschlagen. Zum Wiederholen klicken!

#  _____
# | ____|_ __ _ __ ___  _ __
# |  _| | '__| '__/ _ \| '__|
# | |___| |  | | | (_) | |
# |_____|_|  |_|  \___/|_|
#

# Error Message templates
errorMessageTemplate:
    authError: Sitzung abgelaufen. Bitte melde dich erneut an!
    genericMsg: Es ist ein Fehler aufgetreten. Bitte versuche es erneut!
    key_patientExists: Benutzer:in existiert bereits
    key_noTherapistFound: Kein:e Therapeut:in gefunden
    key_TherapyIDMissing: Therapie-ID fehlt
    key_TherapyNotFound: Therapie nicht gefunden
    key_DeletedSuccess: Erfolgreich gelöscht
    key_WrongTherapy: Falsche Therapie-ID.
    key_PatientNotFound: Patient:in nicht gefunden
    key_FirstNameMissing: Vorname fehlt
    key_LastNameMissing: Nachname fehlt
    key_EmailMissing: E-Mail fehlt
    key_PatientProfileCheck: Überprüfung des Patient:innenprofils fehlgeschlagen
    key_NoProfileFound: Kein Profil gefunden
    key_InvalidAuth0AccountId: Ungültige Auth0-Konto-ID
    key_Unauthorized: Unautorisierter Zugriff
    key_UnauthorizedTherapist: Nicht autorisierte Therapeut:innenanfrage
    key_PasswordResetEmailSent: E-Mail zum Zurücksetzen des Passworts gesendet
    key_UnauthorizedPatient: Nicht autorisierte Patient:innenanfrage
    key_OnBoardingFailed: Das Onboarding ist fehlgeschlagen.
    key_AppointmentNotFound: Termin nicht gefunden
    key_DeleteAppointmentFailed: Termin konnte nicht gelöscht werden. Bitte versuche es erneut.
    key_DeleteAppointmentSuccess: Termin erfolgreich gelöscht
    key_InvalidInputs: Bitte überprüfe deine Eingaben
    key_TrainingNotFound: Trainingsplan nicht gefunden
    key_NoMobileAccess: Mobiler Zugriff nicht zulässig
    key_InvalidPatientLogin: Ungültige Patient:innenanmeldung
    key_InvalidCredentials: Ungültige Zugangsdaten
    key_TagNotFound: Kategorie nicht gefunden
    key_NoAnswerFound: Keine Antwort gefunden
    key_NoQuestionFound: Keine Fragen gefunden
    key_RoomCodeNotFound: Raumcode ungültig
    key_RoomCodeChangeNotAllowed: Du darfst den Raumcode nicht ändern
    key_RoomAlreadyFull: Der Raum ist bereits voll - ist deine Sitzung bereits mit einem anderen Gerät verbunden?
    key_RoomProvidePin: Du musst den PIN-Code für diesen Raum angeben.
    key_RoomAlreadyParticipated: Du hast bereits an dieser Veranstaltung teilgenommen.
    key_RoomParticipationCancelled: Deine Teilnahme wurde storniert.
    key_RoomWrongPin: Falsche Raum-PIN angegeben.
    key_RoomTrainerNotAllowed: Trainer:in darf an dieser Veranstaltung nicht teilnehmen.
    key_RoomNoSessionFound: Sitzung mit Sitzungs-ID mit diesem Raumcode kann nicht gefunden werden
    key_ResetPatientPassword: Aktivierungs-E-Mail erfolgreich an Patienten gesendet
    key_profileUpdatedSuccess: Profil erfolgreich aktualisiert
    key_TherapistMarkedAsTestUser: Therapeut:innenprofil erfolgreich aktualisiert
    key_TherapistPlanUpdatedSuccessful: Versicherungsplan erfolgreich aktualisiert
    key_TemplateDeletedSuccssful: Vorlage erfolgreich entfernt
    key_TrainingTemplateSaved: Vorlage erfolgreich gespeichert
    key_TrainingSavedAsDraft: Trainingsplan erfolgreich als Entwurf gespeichert
    key_TrainingSavedAsDraftFailed: Fehler beim Speichern des Trainingsplans. Bitte bestätige deine Eingaben
    key_OnBoardingAnswerSavedSuccessfully: Antwort erfolgreich gespeichert
    key_NotFound: Nicht gefunden
    key_TherapistPlanUpgradeTitle: Aktualisiere deinen Plan
    key_TherapistPlanUpgradeError: Dein Plan unterstützt nur 2 Patient:innen. Bitte führe ein Upgrade auf den unbegrenzten Plan durch, um mehr Patient:innen anzulegen.
    key_PatientLimitReached: Patient:innenlimit erreicht
    key_FeatureNotAllowed: Funktion nicht aktiviert
    key_PlanCanceled: Plan erfolgreich storniert
    key_NoActivePlanFound: Kein aktiver Plan gefunden
    key_PlanExpried: Plan abgelaufen, bitte melde dich erneut an, um fortzufahren

#  _____                 _
# | ____|_   _____ _ __ | |_
# |  _| \ \ / / _ \ '_ \| __|
# | |___ \ V /  __/ | | | |_
# |_____| \_/ \___|_| |_|\__|
#

# Texts which are shown in the WordPress form after "Teilnehmen" has been clicked
events:
    subscribedResponseText:
        Vielen Dank für deine Anmeldung zu <b>{{eventName}}</b> mit {{trainerName}} am {{dayOfWeekDate}} von {{startTime}} Uhr bis {{endTime}} Uhr.
        <br/>
        Du erhältst eine E-Mail mit allen relevanten Informationen von uns. Bis bald!
    subscribedWaitingListResponseText:
        Vielen Dank für dein Interesse an <b>{{eventName}}</b> mit {{trainerName}} am {{dayOfWeekDate}} von {{startTime}} Uhr bis {{endTime}} Uhr.
        <br/>
        <b>Das Event ist leider schon voll.</b>
        <br/>
        Sollte noch ein Platz frei werden, erhältst du eine E-Mail mit allen relevanten Informationen. Bis bald!

# components/EventCard
eventCard:
    showDetails: Details
    publish: Veröffentlichen
    cancel: Absagen
    enterRoom: Raum betreten
    minutes: '{{count}} Minute'
    minutes_plural: '{{count}} Minuten'

# components/EventDetails
eventDetails:
    columns:
        name: Name
        email: E-Mail
        isEmailConfirmed: E-Mail bestätigt
        isOnlineParticipation: Teilnahme
        status: Status
        actions: Aktionen
        pin: PIN
    columnfilters:
        placeholder:
            name: Gebe Name ein...
            email: Gebe E-Mail ein...
            isEmailConfirmed: Wähle ob E-Mail bestätigt
            isOnlineParticipation: Wähle Art der Teilnahme
            status: Wähle Status
            pin: PIN-Code...
    isOnlineParticipation:
        true: online
        false: vor Ort
    isEmailConfirmed:
        true: ja
        false: nein
    participants:
        header: Teilnehmer:in
        empty: keine angemeldeten Teilnehmer:innen
    waitinglist:
        header: Warteliste
        empty: keine Teilnehmer:innen auf der Warteliste
    notifications:
        resendEmail: Die Erinnerungs-E-Mail wurde gesendet.

# containers/Events/EventsContainer
eventsOverviewPage:
    heading: Gruppenräume
    description: In Gruppenräume kannst du bis zu 20 Personen einladen. Der Raum wird geöffnet, sobald du ihn betrittst. Vorher gelangen die Teilnehmenden in ein virtuelles Wartezimmer.
    createEvent: Neues Event anlegen
    draftEvents: Event-Entwürfe (noch nicht veröffentlicht)
    publishedEvents: Veröffentlichte Events
    inProgressEvents: Gerade laufende Events
    finishedEvents: Beendete Events
    canceledEvents: Abgesagte Events

# eventsContainer
eventsContainer:
    createEvent: Event anlegen
    editEvent: Event bearbeiten
    deleteEvent: Event löschen
    cancelEvent: Event absagen
    deleteEventQuestion: Möchtest du das Event {{name}} wirklich löschen?
    cancelEventQuestion: Möchtest du das Event {{name}} wirklich absagen? Alle Teilnehmer:innen werden per E-Mail benachrichtigt.

# components/events/CreateEventForm
createEvent:
    labels:
        name: Name des Events
        description: Beschreibung
        date: Datum
        startTime: Startzeit
        endTime: Endzeitpunkt
        isOnline: Event findet "online" statt
        hasLocation: Event findet "vor Ort" statt
        locationName: Veranstaltungsort
        locationStreet: Straße
        locationZip: PLZ
        locationCity: Ort
        locationCountry: Land
        locationDirections: Wegbeschreibung
        costs: Ticket Preis
        maxParticipants: Maximale Teilnehmer:innenanzahl
        cancellationPeriod: Stornozeitraum (in h)
        createEvent: Event anlegen
    validation:
        name: Bitte Name des Events eingeben.
        description: Bitte Beschreibung eingeben.
        date: Bitte Datum angeben.
        startTime: Bitte Startzeitpunkt angeben.
        endTime: Bitte Endzeitpunkt angeben.
        startTimeEndTime: Der Endzeitpunkt muss nach dem Startzeitpunkt liegen.
        locationName: Bitte Veranstaltungsort eingeben.
        locationStreet: Bitte Straße eingeben.
        locationZip: Bitte PLZ eingeben.
        locationCity: Bitte Ort eingeben.
        locationCountry: Bitte Land eingeben.
        directions: Bitte Wegbeschreibung eingeben.
        maxParticipants: Bitte maximale Teilnehmer:innenanzahl angeben.
        cancellationPeriod: Bitte maximalen Stornozeitraum in Stunden angeben.

eventStatus:
    DRAFT: Entwurf
    PUBLISHED: veröffentlicht
    CANCELLED: abgesagt
    IN_PROGRESS: läuft gerade
    FINISHED: beendet

subscriptionStatus:
    SUBSCRIBED: angemeldet
    APPROVED: bestätigt
    CANCELLED: abgesagt
    PARTICIPATED: teilgenommen
    PAYED: bezahlt
    JOINED: eingestiegen

#   ____                      _
#  / ___| ___ _ __   ___ _ __(_) ___
# | |  _ / _ \ '_ \ / _ \ '__| |/ __|
# | |_| |  __/ | | |  __/ |  | | (__
#  \____|\___|_| |_|\___|_|  |_|\___|
#

generic:
    cancel: Abbrechen
    delete: Löschen
    close:  Schließen
    save: Speichern
    edit: Bearbeiten
    copy: Kopieren
    pleaseChoose: Bitte wählen
    back: Zurück
    archive: Archiv
    approve: Genehmigen
    reject: Ablehnen
    loading: Wird geladen...
    teleTherapy: Teletherapie
    organizerName: Enlivio
    appointmentSubject: Enlivio Teletherapie Appointment
    therapistFeedback:
        link: https://room4physio.atlassian.net/servicedesk/customer/portal/3/group/4/create/23
        text: Rückmeldung
    fileTooBig: Du versuchst vermutlich eine Datei hochzuladen, die größer als 1 MB ist.
    uploadTitle: Profilbild hochladen
    chooseFileLabel: Klicke hier, um eine Datei auszuwählen (max. 1 MB Größe zulässig)
    uploadImageBtn: Bild auswählen

#  _                    _ _
# | |    __ _ _ __   __| (_)_ __   __ _
# | |   / _` | '_ \ / _` | | '_ \ / _` |
# | |__| (_| | | | | (_| | | | | | (_| |
# |_____\__,_|_| |_|\__,_|_|_| |_|\__, |
#                                 |___/

# components/Landing
landing:
    enterCode: Code eingeben um Raum zu betreten
    enterCodePlaceholder: Code eingeben
    enterRoom: Raum beitreten
    signupNow: Jetzt anmelden
    title:  Physiotherapie per Videokonferenz
    patientsTitle: Für Patient:innen
    trainersTitle: Für Physiotherapeut:innen
    onlineTraining: >
        Die online Physio-Stunde, <br />
        um Patient:innen auch in Zeiten der Krise zu betreuen
    codeveloped: Von Physiotherapeut:innen mitentwickelt
    signupAs: Als Physiotherapeut:in anmelden

#  _                     _
# | |    ___  __ _  __ _| |
# | |   / _ \/ _` |/ _` | |
# | |__|  __/ (_| | (_| | |
# |_____\___|\__, |\__,_|_|
#            |___/

# components/PrivacyModal:
privacyModal:
    contactSupport: Support kontaktieren
    iAgree: Ich stimme zu
    body: >
        Mit der Nutzung von Enlivio stimmst Du folgenden Punkten zu:<br />
        <span role="img" aria-label="lock"> 🔒 </span> Bild und Ton der folgenden Therapiesitzung 
        werden sicher verschlüsselt ausschließlich an dein:e Therapeut:in übertragen <br />
        <span role="img" aria-label="lock"> 🏋️ </span> Zur Verdeutlichung von Übungen kann dein:e 
        Therapeut:in Standbilder (Screenshots/Bildschirmfotos) erstellen, kommentieren 
        zum Download zur Verfügung stellen <br />
        <span role="img" aria-label="lock"> 🙅 </span> Du kannst dich jederzeit <b>stumm- oder die Kamera ausschalten</b>. 
        🔏 Bitte beachte unsere Hinweise zum 
        <a rel="noopener noreferrer" href="https://www.enlivio.com/datenschutz" target="_blank">
        Datenschutz</a>.

#  _   _       _   _  __ _           _   _
# | \ | | ___ | |_(_)/ _(_) ___ __ _| |_(_) ___  _ __
# |  \| |/ _ \| __| | |_| |/ __/ _` | __| |/ _ \| '_ \
# | |\  | (_) | |_| |  _| | (_| (_| | |_| | (_) | | | |
# |_| \_|\___/ \__|_|_| |_|\___\__,_|\__|_|\___/|_| |_|
#

notification:
    fcmNewDeviceLoginTitle: Neue Geräteanmeldung!
    fcmNewDeviceLoginBody: Dein Konto wurde auf einem anderen Gerät angemeldet, du wurdest von diesem Gerät automatisch abgemeldet!
    fcmAppointmentCreatedTitle: Neuer Termin geplant
    fcmAppointmentCancelTitle: Termin abgesagt
    fcmAppointmentCancelBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime gelöscht
    fcmAppointmentConfirmTitle: Termin bestätigt
    fcmAppointmentConfirmBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime bestätigt
    fcmAppointmentRejectTitle: Termin abgelehnt
    fcmAppointmentRejectBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime abgelehnt
    fcmAppointmentCreatedBody: Dein:e Therapeut:in hat einen neuen Termin für $appointmentDateTime erstellt.
    fcmAppointmentRemovedTitle: Termin abgesagt
    fcmAppointmentRemovedBody: Dein:e Therapeut:in hat den Termin am $appointmentDateTime gelöscht
    fcmNewChatMessageTitle: Du hast eine neue Nachricht
    fcmNewChatMessageBody: Bitte öffne die App, um sie anzuzeigen und zu antworten

sendgridTemplates:
    SupportEmail: support@enlivio.com
    BookP_1_Registration: d-305c1da7b6994877b8edb74314360f71
    BookP_2_Confirmation_Offline: d-364ddfdb0c374c6ca5526e970ce23833
    BookP_2_Confirmation_Online: d-55109ee14d5042c98fd3cbaccde78f2d
    BookP_3_Reminder_Offline: d-18f615024c1742bb87afe1910e64563a
    BookP_3_Reminder_Online: d-3bb77e1585674617b0d770407e7657b6
    BookP_5_WaitingList: d-accf851aded44c3aadd8913434c0ccde
    BookP_4_ThankYouMail: d-3dac51175513483ca18f7479cbf3f7bd
    BookP_6_Cancellation: d-0a1dc4fbf9144aebbd5fabb864824746
    BookP_7_Cancellation_ByParticipant: d-cbbb828bc9b44b399b1217fd835fe71a
    BookP_8_Cancellation_OfSubscription: d-07adea67a36943e98fc18a76c9f94d6d
    BookP_9_Reminder_Online_LastMinute: d-bf18a5b5283146baaf877c3f3c842b4f
    BookP_9_Reminder_Offline_LastMinute: d-bf5f0cefcd9d44a38916ee2e217ace03
    BookT_1_NewRegistration: d-f409f50c9cc8486693dd11e56aa365a7
    BookT_1_NewRegistration_WaitingList: d-5fa0c86771024387b44e707fe1c908c2
    BookT_2_Reminder_Hybrid: d-c3efd7420941463bbb5c7b202ffdcf1a
    BookT_2_Reminder_OfflineOnly: d-49a0fd922cbe4cfc8deab2e3ea4efb34
    BookT_2_Reminder_OnlineOnly: d-de8d04b314ba4f6e9c0ea7d4e154f2af
    BookT_3_Cancellation: d-d6d826dbb2934f4c8d04bc475d4e1f35
    BookT_4_CancellationParticipant: d-e24c503ae3044f8d877fd75788bfbe3b
    BookT_5_ThankyouNote: d-0bed657083a14580adb24b8c3d32845e
    MApp_Patient_0_Welcome_Combined: 15
    MApp_Patient_Reset_Password: 18
    APP_Feedback_Email: 19
    Trainingplan_expired_DE: 20
    Therapist_FirstMail: 21
    Patient_MeetingAccepted: 24
    Patient_MeetingCancelled: 26
    Patient_MeetingRejected: 25
    Therapist_NewMeeting: 22
    Therapist_MeetingCancelled: 23
    Patient_NewMeetingByTherapist: 29
    Therapist_Chat_Notification: 35

#  ____       _   _            _
# |  _ \ __ _| |_(_) ___ _ __ | |_
# | |_) / _` | __| |/ _ \ '_ \| __|
# |  __/ (_| | |_| |  __/ | | | |_
# |_|   \__,_|\__|_|\___|_| |_|\__|
#

# components/CreatePatientForm
createPatientForm:
    intro: >
        Lege <strong>pro Patient:in ein Konto</strong> an.<br />
        Patient:innen erhalten danach eine Email um ihr persönliches Passwort zu erstellen und Zugriff auf die Mobile App zu bekommen. Du kannst mit Patient:innen jedoch auch eine Teletherapie ohne Mobile-App durchführen.
    firstName: Vorname Patient:in
    lastName: Nachname Patient:in
    email: E-Mail-Adresse
    seniorMode: Senioren-Modus standardmäßig aktivieren?
    shouldSendInviteEmail: Einladung per E-Mail versenden
    createRoomAndSendEmail: Raum anlegen & Einladung versenden
    createRoom: Patient:in anlegen
    patientProfile: Mobile-App Profil für Patient:in aktivieren?
    invalidFirstName: Bitte gib einen gültigen Vornamen an.
    invalidLastName: Bitte gib einen gültigen Nachnamen an.
    invalidEmail: Bitte gib eine gültige E-Mail-Adresse an.
    consentPatientHTML: Durch das Erstellen einer Patient:in erkenne ich an, dass der/die Patient:in in der Lage ist, gemäß der <a href="https://www.enlivio.com/intendeduse" target="_blank">Zweckbestimmung</a> zu trainieren.
    contraindication:
        contraindicationMsg: Der/die Patient:in hat keine dieser Kontraindikationen
        intendedUseMsg: Der/die Patient:in kann gemäß der Zweckbestimmung teletherapeutisch behandelt werden.
        title: Verwendungszweck und Kontraindikationen
        titleIntro: Enlivio ist nur für Patient:innen verfügbar, bei denen keine Kontraindikationen vorliegen. Stelle sicher, dass keine der folgenden Kontraindikationen bestehen.
        body:
            <h1><strong>Zweckbestimmung</strong></h1>
            <p>Bitte beachte die Zweckbestimmung<p>
            <p>Mit enlivio können Therapeut:innen und Ärzt:innen ihre Patient:innen teletherapeutisch betreuen
            und personalisierte Bewegungstherapie zu Hause anbieten. Die Software enlivio selbst trifft
            keine medizinischen oder therapeutischen Entscheidungen. Alle medizinischen und therapeutischen
            Entscheidungen, sowie die Nutzung von enlivio zur teletherapeutischen Betreuung werden durch das
            medizinische Fachpersonal (im Folgenden “Therapeu:in” genannt) getroffen, dazu gehören Berufe der
            gehobenen medizinisch-technischen Dienste (MTD) (wie zum Beispiel Physiotherapeuten oder Ergotherapeuten). <br>
            <strong>Wichtig:</strong> Die Nutzung von enlivio kann einen Besuch beim Therapeuten oder Arzt/Ärztin nicht ersetzen.</p>
            <p>Patient:innen mit folgenden Merkmalen können mit enlivio betreut werden:</p>
            
            <p><strong>Allgemein:</strong> Patient:innen müssen über 18 Jahre alt sein. </p>
            
            <p><strong>Medizinische Voraussetzungen:</strong> Die Nutzung von enlivio ist ausschließlich
            für Patient:innen geeignet, die für eine medizinische Bewegungstherapie geeignet sind. Die Entscheidung
            für die teletherapeutische Behandlung von Patient:innen obliegt immer dem/der Therapeut:in. Enlivio ist für
            die Bereiche a) Orthopädie und Traumatologie, b) Neurologie und c) Innere Medizin als Medizinprodukt zertifiziert.
            Wichtig ist, dass bei entsprechenden Kontraindikationen die Nutzung von enlivio nicht zulässig ist.
            
            <p><strong>Technische Voraussetzungen:</strong> Patient:innen müssen im Besitz eines internetfähigen Smartphones oder
            Tablets sein und dieses eigenständig benützen können. Es werden ausschließlich Endgeräte mit einem Android Betriebssystem
            mit Version 5.0 oder höher, beziehungsweise mit einem iOS Betriebssystem mit Version 12.0 oder höher unterstützt. Regelmäßige
            Updates der Software sind verpflichtend, um ein sicheres teletherapeutisches Training ermöglichen zu können.
            <hr>
            <h1><strong>Kontraindikationen</strong></h1>
            <p>Die enlivio App ist für unterschiedliche medizinische Indikationen und Fachbereiche nutzbar</p>
            <ul>
            <li>- Orthopädie und Traumatologie</li>
            <li>- Neurologie</li>
            <li>- Innere Medizin</li>
            </ul>
            <p>Die Entscheidung welche Patient:innen mit der App teletherapeutisch betreut werden, liegt immer
            bei dem/der behandelnden Therapeut:in, dem/der behandelnden Ärzt:in.
            Die App trifft keine medizinischen Empfehlungen, Diagnosen oder andere medizinischen oder therapeutischen Entscheidungen,
            ob und in welchem Ausmaß ein:e Patient:in zu behandeln ist.</p>
            <p>Die enlivio App ist für bestimmte Kontraindikationen (unabhängig vom medizinischen Bereich) <strong>nicht nutzbar</strong>.
            In unterstehender Tabelle sind die Kontraindikationen dargestellt</p>
            <table class="table table-bordered">
            <tbody>
            <tr>
            <td class="confluenceTd">
            <p><strong>Medizinischer Bereich</strong></p>
            </td>
            <td class="confluenceTd">
            <p><strong>Kontraindikation</strong></p>
            </td>
            </tr>
            <tr>
            <td class="confluenceTd">
            <p>Orthopädie und Traumatologie</p>
            </td>
            <td class="confluenceTd">
            <p>Alle Arten von akuten Syndromen/Verletzungen/Infektionen oder Verschlimmerungen/Exazerbationen von chronischen Krankheiten</p>
            <p>Krankheitsbilder, die einen akuten chirurgischen oder anderen medizinischen Eingriff erfordern</p>
            <p>Zustände mit akut erhöhtem Verletzungs- oder Sterberisiko</p>
            <p>Systemische Erkrankungen/Zustände, die nicht durch physiotherapeutische Interventionen behandelt werden können</p>
            <p>Systemische Erkrankungen/Zustände, die zu einem erhöhten Verletzungsrisiko während des Trainings führen
            (z. B. Schwindel, wiederholte Stürze, etc.) oder den/der Patienten:in daran hindern, richtig /
            selbständig zu trainieren (z. B. Immobilität, erhebliche kognitive Defizite, …)</p>
            <p>Trainieren unter (zu starken) Schmerzen, d.h. ohne angepasste Schmerzmedikation</p>
            </td>
            </tr>
            <tr>
            <td class="confluenceTd">
            <p>Neurologie</p>
            </td>
            <td class="confluenceTd">
            <p>Neglect</p>
            <p>Patient:innen mit inakzeptablem Sturzrisiko</p>
            <p>Inakzeptable kognitive Einschränkungen/ kognitive Beeinträchtigungen</p>
            <p>Neurodegenerative Erkrankungen oder akute Zustände, die den/die Patient:in daran hindern, Aufgaben selbstständig
            auszuführen (z. B. Immobilität)</p>
            <p>Akute Infektionen oder Verschlimmerungen von chronischen Krankheiten/ Exazerbationen, die eine medizinische
            Behandlung erfordern</p>
            <p>Zustände, bei denen der/die Patient:in bewusstlos ist, schläft oder anderweitig in seiner Aufmerksamkeit eingeschränkt ist</p>
            <p>Zustände, die einen Krankenhausaufenthalt und/oder medizinische Überwachung erfordern</p>
            <p>Systemische Erkrankungen/Zustände, die nicht durch physiotherapeutische Intervention behandelt werden können</p>
            <p>Zustände, die eine akute chirurgische oder andere medizinische Intervention erfordern</p>
            </td>
            </tr>
            <tr>
            <td class="confluenceTd">
            <p>Innere Medizin</p>
            </td>
            <td class="confluenceTd">
            <p>Patient:innen mit körperlichen oder psychischen/geistigen Beeinträchtigungen, die nicht ausreichend belastbar und/oder
            nicht mobilisierbar sind und daher die Maßnahmen der Tele-Rehabilitation nicht aktiv nutzen können</p>
            <p>Akute Selbst- oder Fremdgefährdung</p>
            <p>Akute oder dekompensierte Krankheitszustände, die eine Rehabilitationsfähigkeit ausschließen (z. B. dekompensierte
            Herzinsuffizienz, schwere Herzklappeninsuffizienz, akute Lungenembolie, akutes Koronarsyndrom (AKS))</p>
            <p>Akute Exazerbation einer chronisch-obstruktiven Lungenerkrankung oder akute Exazerbationen einer chronischen
            Bronchitis (AECB) sowie eine plötzliche Verschlechterung der Symptome einer chronisch-obstruktiven Lungenerkrankung (COPD)
            einschließlich Kurzatmigkeit</p>
            <p>Akute Asthma-Exazerbation oder progressive Verschlechterung von Asthmasymptomen, einschließlich Atemnot, Keuchen,
            Husten und Engegefühl in der Brust</p>
            <p>Medizinische Erkrankungen, die einen akuten chirurgischen oder anderen medizinischen Eingriff erfordern</p>
            <p>Akute/floride Infektionskrankheiten</p>
            <p>Unzureichende diagnostische Abklärung</p>
            <p>NYHA IV Herzinsuffizienz</p>
            <p>Höhergradige Obstruktion des linksventrikulären Ausflusstrakts (Aortenstenose, hypertrophisch-obstruktive Kardiomyopathie (KMP))</p>
            </td>
            </tr>
            </tbody>
            </table>
            <p>Die Verwendung von enlivio kann einen traditionellen Besuch bei Ärzt:innen oder Therapeut:innen nicht ersetzen. Für eine abschließende und umfassende Behandlung ist der Besuch von
            Ärzt:innen und Therapeut:innen vor Ort oder in dringenden Fällen ein Besuch
            in einem Krankenhaus erforderlich. Für die medizinische Versorgung über das Internet gelten besondere berufsrechtliche
            Regelungen und Einschränkungen (z. B. schriftliche Bestätigung der Patient:innen zur Erlaubnis der Datenübertragung
            über das Internet erforderlich).</p>
        save: Akzeptieren
        mouseOver: Bitte akzeptiere die Zweckbestimmung und den Ausschluss der Kontraindikationen.

# components/Patienten
patients:
    createNewGroupRoom: Neuen Gruppenraum anlegen
    createInstantRoom: Einmal-Raum öffnen
    enterRoom: Raum betreten
    groupRooms: Gruppenräume
    editGroupRoom: Gruppenraum bearbeiten
    createGroupRoom: Gruppenraum anlegen
    deleteGroupRoom: Gruppenraum löschen
    deleteGroupRoomQuestion: Willst du wirklich den Gruppenraum "{{id}} {{name}}" löschen?
    therapistBadge: TEST-ACCOUNT
    heading: Patient:innen
    introText:
        <h1>Patient:innen:übersicht</h1>
        <p>Hier sehst du alle Patient:innen, für die du ein Konto angelegt hast.</p>
        <p>Wenn du auf einen Patient:in klickst kannst Du Trainingspläne und Termine erstellen.</p>
    createNewP2PRoom: Patient:in anlegen
    createPatient: Patient:in anlegen
    editPatientRoom: Patient:in bearbeiten
    createPatientRoom: Patient:innen-Konto anlegen
    deletePatientRoom: Patient:innen-Konto löschen
    deletePatientRoomQuestion: Willst du wirklich den/die Patient:in {{firstName}} {{lastName}} löschen?
    noPatients: Du hast noch keine Patient:innen angelegt.
    archivePatientTitle: Patient:in archivieren
    archivePatientBody: Diese:r Patient:in wird archiviert, die Daten sind danach nicht mehr zugänglich und werden nur im Rahmen der gesetzlichen Aufbewahrungspflichten gespeichert.
    daysRemainingLabel: Tage
    searchLabel: Suche
    noPatientFound: Keine Patient:innen gefunden
    tableHeader:
        name: Name
        program: Programm
        nextTherapy: Nächste Therapie
        trainingPlan: Trainingsplan

#   ___                  _   _                         _
#  / _ \ _   _  ___  ___| |_(_) ___  _ __  _ __   __ _(_)_ __ ___
# | | | | | | |/ _ \/ __| __| |/ _ \| '_ \| '_ \ / _` | | '__/ _ \
# | |_| | |_| |  __/\__ \ |_| | (_) | | | | | | | (_| | | | |  __/
#  \__\_\__,_|\___||___/\__|_|\___/|_| |_|_| |_|\__,_|_|_|  \___|
#

#components/Proms
proms:
    heading: Fragebogen
    introText: >
        <h1>Fragebogen:übersicht</h1>
        <p>Hier siehst du alle Fragebögen, die zurzeit zur Verfügung stehen</p>
        <p>Klicke auf einen Fragebogen, um diesen deiner Patient:in zuzuweisen. Der Fragebogen wird erst dann für die Patient:in sichtbar, sobald du diesen aktivierst und die Änderungen speicherst.</p>
    createProm: Fragebogen anlegen
    editProm: Fragebogen bearbeiten
    deleteProm: Fragebogen löschen
    deletePromQuestion: Willst du den Fragebogen wirklich löschen?
    draftPromQuestion: Willst du den Fragebogen wirklich auf "Entwurf" setzen?
    publishPromQuestion: Willst du den Fragebogen wirklich veröffentlichen?
    saveButton: Änderungen speichern
    saveText: Gespeichert!
    every training: jedes Training
    once a week: wöchentlich

#components/AnswerAndActivity
answerAndActivity:
    warningText: Bitte beachte dass die untenstehenden Informationen rein auf subjektiven Selbsteinschätzungen der Patient:innen basieren und keine wissenschaftlichen, medizinischen oder physiologischen Messwerte widerspiegeln, und somit nicht zur Findung von Therapieentscheidungen dienen. Eine professionelle Einschätzungen im Rahmen eines persönlichen Gesprächs oder einer Visite ist für Therapieentscheidungen dadurch erforderlich.
    answerTitle: Antworten auf Fragebögen
    activityTitle: Trainingsstatistik
    AbortedText:
        NOTFIT: Ich fühle mich nicht fit
        NOTIME: Ich habe keine Zeit
        NOANSWER: Ich möchte keinen Grund angeben
    noActivity: Die Patient:in hat noch keine Trainings durchgeführt.
    noTrainingPlanActivity: Die Patient:in hat noch keine Trainings durchgeführt.
    noAnswer: Die Patient:in hat noch keine Fragebögen beantwortet.
    SKIPPED: 'Ausgelassen:'
    AbortedLabel: Grund des Abbruchs
    GeneralFeedback: Generelle Rückmeldung
    ReasonToAbort: Grund zum Abbruch
    ExerciseStatusABORTED: ABGEBROCHEN
    ExerciseStatusDONE: ABGESCHLOSSEN
    ExerciseStatusSKIPPED: AUSGELASSEN
    ExerciseStatusDONEWITHSKIPS: TEILS AUSGELASSEN
    ExerciseLabel: Übung
    TrainingCompleted: abgeschlossene Trainings
    trainingPlanFrom: Trainingsplan von {startDate} - {endDate}
    viewTrainingPlanBtn: Trainingsplan ansehen
    viewTrainingPlanModal:
        workoutsPerWeek: pro Woche
        workoutPause: Sekunden Pause
    WeekText: Woche
    CurrentText: Aktuell
    Months: Januar, Februar, März, April, Mai, Juni, Juli, August, September, Oktober, November, Dezember
    ShortMonths: Jan, Feb, Mär, Apr, Mai, Jun, Jul, Aug, Sep, Okt, Nov, Dez

# components/CreateUpdatePromForm
createUpdatePromForm:
    questionnaire: Fragebogen
    triggers: Auslöser
    triggerType: Auslöser-Typ
    triggerExercise: Übung
    triggerWorkout: Workout
    triggerTypeEveryday: Täglich
    triggerTypeEveryWeek: Wöchentlich
    triggerTypeEverySecondWeek: Jede zweite Woche
    triggerTypeAfterExercise: Nach Übung
    triggerTypeBeforeExercise: Vor Übung
    triggerTypeAfterWorkoutWeek: Nach Workout
    triggerTypeBeforeWorkoutWeek: Vor Workout
    triggerWorkoutNotAvailable: Nicht verfügbar
    addTrigger: Auslöser hinzufügen
    saveProm: Speichern
    savePromSuccess: Erfolgreich gespeichert
    savePromError: Etwas ist schief gelaufen

#  ____
# |  _ \ ___   ___  _ __ ___
# | |_) / _ \ / _ \| '_ ` _ \
# |  _ < (_) | (_) | | | | | |
# |_| \_\___/ \___/|_| |_| |_|
#

pin:
    enterRoom: Raum beitreten
    enterPinCode: PIN-Code
    error-generic: Leider konnte eine Verbindung zum Gruppenraum nicht hergestellt werden. Bitte versuchen Sie es erneut!
    error-required: Bitte PIN-Code eingeben, um dem Raum beizutreten.
    error-participated: Dein PIN-Code wird schon von einer anderen Teilnehmer:in verwendet.
    error-cancelled: Dein Teilnahme an diesem Event oder das Event wurde storniert.
    error-room-not-found: Es konnte kein Gruppenraum unter dem code {{roomCode}} gefunden werden.
    error-wrong: Der PIN-Code ist falsch.
    error-wrong-trainer: Du bist nicht berechtigt, diesem Event als Trainer:in beizutreten.

room:
    waiting:
        welcome: Willkommen bei Enlivio!
        title1: Bitte drücke auf den Button
        title2: um bei dem Videogespräch teilzunehmen!
        patientText: Bitte einen Augenblick! Du wirst verbunden, sobald dein Veranstalter an der Besprechung teilnimmt
        hostText: Bitte einen Augenblick! Du wirst verbunden, sobald dein Teilnehmer an der Besprechung teilnimmt
        isConnecting: Du wirst in Kürze verbunden ...
    screenshot:
        not-possible: Deine Patient:in hat die Kamera deaktiviert. Du kannst nur Screenshots machen wenn deine Patient:in die Kamera aktiviert.
    controls:
        cameraSwitch:
            changeActiveCamera: Aktive Kamera auswählen
            selectCameraFromList: Wähle deine Kamera von der folgenden Liste
            changeCamera: Kamera wechseln
    endCall:
        confirmButton: Zimmer verlassen
        title: Bist du sicher?
        body: Der Raum wird geschlossen, wenn du zurückkehrst, muss dieser erneut geöffnet werden.

#  ____  _                        _
# / ___|| |__   __ _ _ __ ___  __| |
# \___ \| '_ \ / _` | '__/ _ \/ _` |
#  ___) | | | | (_| | | |  __/ (_| |
# |____/|_| |_|\__,_|_|  \___|\__,_|
#

# components/Uploader
uploader:
    dropZoneText: Bild hier ablegen oder
    dropZoneButtonLabel: Auswählen
    downloadButtonLabel: Herunterladen

# components/DeleteFileModal
deleteFileModal:
    title: Bild löschen
    question: Willst du dieses Bild löschen?

# components/RechargeCredits
rechargeCredits:
    labels:
        email: Email
        creditHours: Credits in Stunden
    buttons:
        addCredits: Credits hinzufügen

# components/Header
header:
    eventsNav: Gruppen
    imagesNav: Bilder
    contactNav: Kontakt
    adminNav: Admin
    accountNav: Account
    myAccountNav: Mein Account
    logoutNav: Logout
    roomsNav: Räume
    signinNav: Einloggen
    contactHeader: Kontakt
    therapiesNav: Therapien
    patientsNav: Patient:innen
    messages: Mitteilungen
    contactModalBody: Du kannst uns unter <a rel="noopener noreferrer" href="mailto:info@enlivio.com" target="_blank">info@enlivio.com</a> kontaktieren.
    appointments: Termine

# components/Footer
footer: >
    <span class="float-left center-xs">© Enlivio 2022</span> <span class="float-right">
    <a rel="noopener noreferrer" href="mailto:info@enlivio.com" target="_blank"> info@enlivio.com </a> |
    <a href="https://www.enlivio.com/hilfe/" target="_blank"> Hilfe </a> |
    <a href="/about"> Über </a> |
    <a href="https://www.enlivio.com/impressum/" target="_blank"> Impressum </a> |
    <a href="https://www.enlivio.com/wp-content/uploads/2021/11/AGB_Enlivio_B2B_v3_inclAVV_Physio.pdf" target="_blank"> AGB </a> |
    <a href="https://www.enlivio.com/wp-content/uploads/2021/11/20211027-heyData_Datenschutzerkla%CC%88rung-Website_DE_room4-Softwareentwicklung-GmbH_https___app.enlivio.com-1.pdf" target="_blank">Datenschutz</a>
    </span>

# containers/404
notFound:
    subTitle: Etwas ist schief gelaufen
    body:  Die von dir gesuchte Seite wurde verschoben, entfernt oder existierte möglicherweise nicht.
    buttonText: Zurück nach Hause

# __        __         _               _
# \ \      / /__  _ __| | _____  _   _| |_
#  \ \ /\ / / _ \| '__| |/ / _ \| | | | __|
#   \ V  V / (_) | |  |   < (_) | |_| | |_
#    \_/\_/ \___/|_|  |_|\_\___/ \__,_|\__|
#

#containers/Workouts/WorkoutsContainer
workouts:
    introText: >
        <h1>Trainings-Plan</h1>
        <p>Mit dem Trainings-Plan können deine Patient:innen Übungen mit Hilfe der Mobile-App zuhause machen.</p>
    createTraining: Trainingsplan erstellen
    editTraining: Trainingsplan bearbeiten
    workoutCreateFCMTitle: Neuer Trainingsplan
    workoutCreateFCMBody: Deine Therapeut:in hat dir einen neuen Trainingsplan zugewiesen
    workoutUnpublishedFCMTitle: Trainingsplan deaktiviert
    workoutUnpublishedFCMBody: Dein Trainingsplan wurde deaktiviert.

#components/workouts/Workout
workout:
    labels:
        title: 'Titel:'
        calendarWeek: 'Kalenderwoche:'
        noteTherapist: 'Anmerkung:'
        exerciseTitle: 'Titel:'
        exerciseType: 'Typ:'
        knee: Knie
        shoulder: Schulter
        hip: Hüfte
        back: Rücken
        neck: Nacken
        dynamicCondition: 'Dynamisch:'
        breakBetweenSets: 'Pause zwischen Sätze (Sek):'
        exerciseNoteTherapist: 'Hinweise:'
        exerciseSets: 'Sätze:'
        exerciseSetRepetitions: Wdh

#components/trainingPlaxns/TrainingPlanDetails
trainingPlan:
    labels:
        trainingInterval: 'Trainingsintervall:'
        activeExercise: '{{index}}. Übung'
        repetitions: 'Wiederholungen:'
        sets: 'Sätze:'
        comment: 'Anmerkungen:'
        downloadPdf: PDF downloaden (passwortgeschützt)
    unpublish:
        title: Trainingsplan deaktivieren
        body: Deine Patient:in kann keine Trainingspläne sehen bis ein Trainingsplan veröffentlicht wurde.
        button: Deaktivieren
    trainingPlanFor: Trainingsplan für
    trainingPlanGenericError: Der Trainingsplan kann nicht veröffentlicht werden, weil es bei den folgenden Trainings noch Fehler gibt. Bitte alle Übungseinstellungen überprüfen.
    tabLable: Registerkarte
    status:
        UNPUBLISHED: Deaktiviert
        PUBLISHED: Veröffentlicht
        DRAFT: Deaktiviert
    publishUntil: Veröffentlicht bis
    newTabTraning: Training
    saveAndPublish: Veröffentlichen
    saveAsDraft: Entwurf speichern
    saveAndPublishModal:
        body: Der Trainingsplan wird für den angegeben Zeitraum veröffentlicht.
        label: gültig bis
        isGlobalLabel: Als globale Vorlage speichern?
        templateLabel: Kategorie
        templatePlaceHolder: e.g Rückenschmerzen
        templateHelpText: Der Kategoriename wird verwendet, damit du deine Vorlagen besser wiederfinden kannst.
    validation:
        date: ungültiges Datum
        greaterDate: Dauer darf nicht über 4 Wochen sein
        pastDate: Datum kann nicht in der Vergangenheit liegen
        templateName: Kategoriename ist erforderlich
        futureDate: Datum länger als 2 Monate kann nicht ausgewählt werden
        invalidDate: Ungültiges Datum! Das korrekte Datumsformat ist TT-MM-JJJJ
    unSavedWarning: Alle ungespeicherten Änderungen gehen verloren. Willst Du wirklich fortfahren?

#components/trainingPlans/TrainingPlanForm
trainingPlanForm:
    title: Trainings
    addTraining: Training hinzufügen
    loadTemplate: Vorlagen laden
    saveAsTemplateTitle: Als Vorlage speichern
    saveAsTemplate: Vorlage speichern
    templateModalTitle: Vorlagen Laden
    templateModalButton: Ausgewählte Vorlage hinzufügen
    templateModalError: Max 4 Trainings können zu einem Trainingsplan hinzugefügt werden. Bitte lösche einige, bevor du weitere hinzufügen kannst.
    templateModalNoTemplate: Vorlage nicht gefunden
    templateModalConfirm: Bestätigen
    perWeek: pro Woche
    trainingName: Trainings-Name
    trainingNameValidation: Bitte einen Namen eingeben.
    workoutsPerWeek: Trainings pro Woche
    workoutsPerWeekValidation: Muss zwischen 1 und 7 Trainings sein.
    workoutPause: Pause zwischen den Übungen
    workoutPauseValidation: Pause muss zwischen 10 und 180 Sekunden sein.
    deleteTraining: Training löschen
    deleteTrainingBody: Möchtest du das Training wirklich löschen?
    exercise: Übungen
    noExercise: Noch keine Übungen.
    pauseGroup: Sekunden
    yourTemplateText: Deine Vorlagen
    globalTemplateText: Globale Vorlagen
    deleteTemplateTitle: Vorlage löschen
    deleteTemplateBody: Willst du die Vorlage {templateName} wirklich löschen?

#components/trainingPlans/AddExerciseModal
exerciseModal:
    title: Übung hinzufügen
    addStaticExercise: Benutzerdefinierte Übung
    addDynamicExercise: Eigene dynamische Übung
    addEnduranceExercise: Ausdauerübung
    filterText: Filter
    filterClearText: Filter löschen
    selectionDone: Ausgewählte Übungen hinzufügen
    customExercise:
        enName: Custom Exercise
        deName: Benutzerdefinierte Übung
        enDescription: Custom Exercise
        deDescription: Benutzerdefinierte Übung
    enduranceExercise:
        enName: Name of the Endurance Exercise
        deName: Name der Ausdauerübung
        enDescription: Description of the Endurance Exercise
        deDescription: Beschreibung der Ausdauerübung

#components/trainingPlans/AddExerciseModal
exerciseCard:
    deleteExercise:
        title: Übung löschen
        body: Bist du sicher dass du die Übung löschen willst?
    validation:
        name: Bitte einen Namen eingeben.
        description: Bitte eine Beschreibung eingeben.
        greaterSets: Viele Sätze.
        lowerSets: Wenige Sätze.
        greaterRepetition: Viele Wiederholungen.
        lowerRepetition: Wenige Wiederholungen.
        greaterTime: Hohe Übungsdauer.
        lowerTime: Niedrige Übungsdauer.
        invlaidValue: Ungültiger Wert.
    form:
        name: Übungs-Namen
        description: Übungs-Beschreibung
        skipPause: Pause danach auslassen
        skipPauseDescription: Wenn diese Option aktiviert ist, muss die Patient:in zwischen den Sätzen dieser Übung und vor der nächsten Übung keine Pause einlegen. Verwende dies für Aufwärmübungen oder andere Übungen, die keine Erholungszeit benötigen.
        sets: Sätze
        repetition: Wiederholungen
        time: Zeit
        timeGroup: sek
        customDescripton: Benutzerdefinierte Beschreibung
        amount: Volumen (Zeit/Wdh.)
        dropdown:
            sec: Sek
            min: Min
            reps: Wdh